module.exports = __webpack_public_path__ + "static/media/map_solid_bg.0ec89a74.jpg";